<ion-header *ngIf="false">
  <ion-toolbar>
    <ion-title>{{title}} Specifications</ion-title>
    <ion-icon  (click)="modal.dismiss()" slot="end" name="close-outline" class="close"></ion-icon>
    <!-- <ion-icon *ngIf="title == 'Edit'" (click)="nav_back()" slot="end" name="close-outline" class="close"></ion-icon> -->
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="list">
    <div class="d__flex header">
      <div>
        <h6 class="m-0 heading__">{{title}} Specifications</h6>
      </div>
      <ion-icon (click)="modal.dismiss()" class="mouse" name="close-outline"></ion-icon>
    </div>
    <div class="content">
      <div>
        <div class="m-0 label position-relative d__flex ion-align-items-center">
          <span class="op-7">Select Atrributes</span>
         
        </div>
       
          <!-- <ion-select label="Attribute Name" class="sO" [(ngModel)]="spec.specification_attribute" name='attr' interface="popover" (ionChange)=attr_Change($event)>
            <ion-select-option  *ngFor="let d of db.specifications_attributes" value='{{ d.attribute_name }}'>{{ d.attribute_name }}</ion-select-option>
          </ion-select> -->
  
          <ng-select #select [items]="db.specifications_attributes" class="medium_name"
                    [placeholder]="'Select'"
                    [(ngModel)]="spec.specification_attribute"
                    (change)="attr_Change($event)"
                    [clearable]="false"
                    [searchable]="false"
                    bindLabel="attribute_name"
                    bindValue="attribute_name"
                    [multiple]="false"
                    [searchFn]="db.CustomSearch" 
                    (click)="focusof()"
                    (search)="db.onSearch($event)">
                    <ng-template ng-header-tmp>
                      <div class="custome_input d__flex gap-5 just-s">
                        <input #customInput style="width: 100%;line-height: 25px; border:unset" 
                          [placeholder]="'search'" 
                          type="text" 
                          (input)="select.filter($any($event.target).value)"
                          (change)="$event.stopPropagation()"
                          (keydown)="select.handleKeyDown($event)"/> 
                          <!-- <img style="width: 15px;" src="../../../../assets/icon/search.svg"> -->
                      </div>
                      </ng-template>
          </ng-select> 
  
      </div>
      
      <div>
        <div class="m-0 label position-relative d__flex ion-align-items-center">
          <span class="op-7">Atrribute Id</span>
        </div>
        <ion-input class="sO_1" type="text" name="attr_id" readonly="true" [(ngModel)]="spec.attribute"></ion-input>
      </div>
    
      <div>
        <div class="m-0 label position-relative d__flex ion-align-items-center">
          <span class="op-7">Group</span>
        </div>
        <!-- <ion-select label="Group" class="sO" name="group" interface="popover" (ionChange)=grp_Change($event) [(ngModel)]="spec.spec_group_name">
          <ion-select-option *ngFor="let s of db.specifications_group" value='{{ s.specification_group_name }}'>{{s.specification_group_name}}</ion-select-option>
        </ion-select> -->
  
        <ng-select #select [items]="db.specifications_group" class="medium_name"
                    [placeholder]="'Select'"
                    [(ngModel)]="spec.spec_group_name"
                    (change)="grp_Change($event)"
                    [clearable]="false"
                    [searchable]="false"
                    bindLabel="specification_group_name"
                    bindValue="specification_group_name"
                    [multiple]="false"
                    [searchFn]="db.CustomSearch" 
                    (click)="focusof()"
                    (search)="db.onSearch($event)">
                    <ng-template ng-header-tmp>
                      <div class="custome_input d__flex gap-5 just-s">
                        <input #customInput style="width: 100%;line-height: 25px; border:unset" 
                          [placeholder]="'search'" 
                          type="text" 
                          (input)="select.filter($any($event.target).value)"
                          (change)="$event.stopPropagation()"
                          (keydown)="select.handleKeyDown($event)"/> 
                          <!-- <img style="width: 15px;" src="../../../../assets/icon/search.svg"> -->
                      </div>
                      </ng-template>
                  
          </ng-select> 
      </div>
      
      <div>
        <div class="m-0 label position-relative d__flex ion-align-items-center">
          <span class="op-7">Group Name</span>
        </div>
        <ion-input class="sO_1" type="text" readonly="true" name="group_name" [(ngModel)]="spec.spec_group_name1"></ion-input>
      </div>
      
      <div class="textarea">
        <div class="m-0 label position-relative d__flex ion-align-items-center">
          <span class="op-7">Description</span>
        </div>
        <ion-textarea (input)="change($event)" [rows]="4" class="sO_1" name="desc" [(ngModel)]="spec.options"></ion-textarea>
        <p *ngIf="error_msg" class="m-0 small_name error">Enter the description</p>
      </div>
    </div>

    <div class="button">
      <ion-button *ngIf="this.title == 'Add'" fill="clear" expand="full" class="save-btn" (click)="post_data()" >{{title == 'Edit' ? "Update" : "Save"}}</ion-button>
      <div *ngIf="title == 'Edit'" class="d__flex">
        <ion-button fill="clear" style="width: 70%;" expand="full" class="save-btn" (click)="post_data()" >Update</ion-button>
        <ion-button fill="clear" style="width: 30%;  --background: rgb(235 79 79) !important"   class="delete_btn" *ngIf="this.title == 'Edit'" (click)="delete_combo()" expand="full" class="save-btn"  >Delete</ion-button>
      </div>
    </div>
  </div>
  
</ion-content>

<!-- <ion-footer>
   
</ion-footer> -->
